import {
  GET_ALL_REGIONS,
  GET_ALL_REGIONS_SUCCESS,
  GET_ALL_REGIONS_ERROR
} from './constants';

export const getAllRegions = () => ({
  type: GET_ALL_REGIONS
});

export const getAllRegionsSuccess = (payload) => ({
  type: GET_ALL_REGIONS_SUCCESS,
  payload
});

export const getAllRegionsError = () => ({
  type: GET_ALL_REGIONS_ERROR
});
